module.exports = "/assets/913dc2f5b212187eda176224ed23f9fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/2I.png
// module id = 2115
// module chunks = 0